import { TestWhatApp } from '@src/shared/features/reminders/dialogs/view-reminder-template-details/test-whatsapp';
import { TestEmail } from '@src/shared/features/reminders/dialogs/view-reminder-template-details/test-email';
import type { TReminderTemplate } from '@shared/types/reminder-template';
import { DialogBody, DialogHeader, DialogTitle } from '@design-system/dialog';

import { REMINDER_CHANNELS } from '@shared/types/reminder';
import { LivePreview } from '@src/shared/features/reminders/live-preview';

export const ViewReminderTemplateDetails = ({
  reminderTemplate,
}: {
  reminderTemplate: TReminderTemplate;
}) => {
  const isSyncChannel =
    reminderTemplate.channel === REMINDER_CHANNELS.sms ||
    reminderTemplate.channel === REMINDER_CHANNELS.whatsapp;

  return (
    <>
      <DialogHeader className='shrink-0 border-b border-gray-100'>
        <DialogTitle>{reminderTemplate.name}</DialogTitle>
      </DialogHeader>

      <DialogBody className='flex min-h-0 flex-1 flex-col overflow-hidden p-0'>
        <div className='flex min-h-0 flex-1 flex-col overflow-hidden md:flex-row'>
          <div className='flex min-h-0 w-full shrink-0 flex-col gap-4 overflow-y-auto border-gray-100 p-6 md:w-1/2 md:max-h-full md:border-r md:pr-6'>
            {isSyncChannel ? (
              <TestWhatApp reminderTemplate={reminderTemplate} />
            ) : null}

            {reminderTemplate.channel === REMINDER_CHANNELS.email ? (
              <TestEmail reminderTemplate={reminderTemplate} />
            ) : null}
          </div>

          <div className='flex min-h-[min(280px,45vh)] w-full flex-1 flex-col bg-gray-50 p-6 md:min-h-0 md:w-1/2'>
            <LivePreview
              attachments={reminderTemplate.attachments ?? []}
              channel={reminderTemplate.channel}
              className='min-h-0 flex-1'
              content={reminderTemplate.content ?? ''}
              defaultMode='live'
            />
          </div>
        </div>
      </DialogBody>
    </>
  );
};
